<template>
  <div class="app-container register-content">
    <!-- Google Tag Manager (noscript) -->
    <noscript v-if="hostname === 'myshop.ieshop.co.nz'"><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PGVXKWH"
    height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
    <!-- End Google Tag Manager (noscript) -->

    <div v-if="isMobile === false" v-loading.fullscreen="loading" element-loading-background="rgba(80, 80, 80, 0.8)">
      <div class="box-card register-header">
        <div class="register-header-info">
          <img :src="ieshopLogo" style="height: 60px;">
          <p style="font-size: 28px; color: #fff;">Start your free 30-day trial of IE Shop</p>
        </div>
      </div>
      <div class="box-card register-info">
        <el-form class="pc-form" :model="shopForm" :rules="rules" ref="ruleForm">
          <el-form-item class="pc-form-item" prop="shop_admin_email">
            <el-input
              class="pc-form-input"
              v-model="shopForm.shop_admin_email"
              placeholder="Email"
            ></el-input>
          </el-form-item>
          <el-form-item class="pc-form-item" prop="shop_admin_password">
            <el-input
              class="pc-form-input"
              v-model="shopForm.shop_admin_password"
              placeholder="Password"
              :show-password="true"
            ></el-input>
          </el-form-item>
          <el-form-item class="pc-form-item" prop="display_shop_name">
            <el-input
              class="pc-form-input"
              v-model="shopForm.display_shop_name"
              placeholder="Shop Name"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div class="pc-shop-type-title">Select Industry Template</div>
            <el-radio-group v-model="industryTemplateId">
              <div class="industry-template-radio-container">
                <el-radio-button
                  v-for="(template, index) in industryTemplates "
                  :key="index"
                  :label="template.templateShopId"
                  border=false
                >
                  <div
                    class="industry-template-grid"
                    @mouseover="onMouseoverIndustryImage"
                    @mouseleave="onMouseleaveIndustryImage"
                    @click.stop="onClickIndustryTemplate"
                    :data-label="template.templateShopId"
                    :data-index="index"
                    :style="{
                      'background': 'linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)), url(' + template.backgroundImage + ') center'
                    }">
                    <div class="template-title">
                      {{ template.title }}
                    </div>
                    <div class="preview-buttons" @click.stop>
                      <el-button type="primary" plain size='mini'>
                        <a :href="template.pcPreviewURL" target="_blank">PC Preview</a>
                      </el-button>
                      <el-button
                        @click.stop="showIndustryMobileQRCode(index)"
                        type="primary"
                        plain size='mini'
                      >
                        Mobile Preview
                      </el-button>
                    </div>
                    <div @click.stop class="qrcode-layout" v-show="template.showQRCode">
                      <el-dialog
                        @click.stop
                        @opened="showShopQrCode"
                        :visible.sync="template.showQRCode"
                        :modal-append-to-body="isDialogModalAppendToBody"
                      >
                        <img class="template-QRCode-image" :src="template.QRCodeURL" />
                      </el-dialog>
                    </div>
                    <div class="tick">✓</div>
                  </div>
                </el-radio-button>
              </div>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="shop_type">
            <span class="pc-shop-type-title">Shop Type</span>
            <el-radio-group v-model="shopForm.shop_type">
              <el-radio style="color: #fff;" label="1">Company</el-radio>
              <el-radio style="color: #fff;" label="2">Individual</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item style="margin-top: -20px;">
            <el-checkbox v-model="policy" style="margin-right: 10px;">
              <a
                href="https://img.nzmai.com.cn/FudZoqHWpBxPeY7Lthkk8R7--q3u"
                target="blank"
                style="color: #409EFF;"
              >IE Shop Merchant's Agreement</a>
            </el-checkbox>
            <el-popover
              placement="top-start"
              width="400"
              trigger="hover"
              content="By ticking the 'I Agree' button on the website, prospective IE Shop Merchants who do not have a paying agreement  consent and agree to the terms and conditions in the IE Shop Standard Merchant Agreement, and a copy of which is on the website."
            >
              <el-tag size="mini" slot="reference">?</el-tag>
            </el-popover>
          </el-form-item>
          <div style="text-align: right;">
            <el-button
              @click="createShop"
              class="btn"
            >Create Your Store</el-button>
          </div>
          <div class="go-to-login">
            <span>
              Already have the account?
              <a style="color: #409EFF;" @click="goToLogin">Login</a>
            </span>
          </div>
        </el-form>
      </div>
    </div>
    <div v-else class="register-mobile" v-loading.fullscreen="loading" element-loading-background="rgba(80, 80, 80, 0.8)">
      <div class="box-card mobile-header">
        <div class="register-header-info">
          <img :src="ieshopLogo" style="height: 45px;">
          <div style="padding-top: 20px; font-size: 26px; color: #fff;">Start your free 30-day trial of IE Shop</div>
        </div>
      </div>
      <div class="box-card mobile-register-info">
        <el-form :model="shopForm" :rules="rules" ref="ruleForm" style="width: 100%;">
          <el-form-item prop="shop_admin_email">
            <el-input
              v-model="shopForm.shop_admin_email"
              placeholder="Email"
            ></el-input>
          </el-form-item>
          <el-form-item prop="shop_admin_password">
            <el-input
              v-model="shopForm.shop_admin_password"
              placeholder="Password"
              :show-password="true"
            ></el-input>
          </el-form-item>
          <el-form-item prop="display_shop_name">
            <el-input
              v-model="shopForm.display_shop_name"
              placeholder="Shop Name"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div class="pc-shop-type-title">Select Industry Template</div>
            <el-radio-group v-model="industryTemplateId">
              <div style="display: flex; flex-direction: row; justify-content: center; flex-wrap: wrap;">
                <el-radio-button
                  v-for="(template, index) in industryTemplates "
                  :key="index"
                  :label="template.templateShopId"
                  border=false
                >
                  <div
                    class="industry-template-grid-mobile"
                    @mouseover="onMouseoverIndustryImage"
                    @mouseleave="onMouseleaveIndustryImage"
                    @click.stop="onClickIndustryTemplate"
                    :data-label="template.templateShopId"
                    :data-index="index"
                    :style="{
                      'background': 'linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)), url(' + template.backgroundImage + ') center'
                    }">
                    <div class="template-title-mobile">
                      {{ template.title }}
                    </div>
                    <div class="preview-button-mobile" @click.stop>
                      <el-button
                        type="primary"
                        size='mini'
                        @click.stop="onClickMobilePreview(template.mobilePreviewURL)"
                      >
                        Preview
                      </el-button>
                    </div>
                    <!-- <div class="tick-mobile">✓</div> -->
                  </div>
                </el-radio-button>
              </div>
            </el-radio-group>
          </el-form-item>
          <el-form-item  prop="shop_type">
            <span class="mobile-shop-type-title">Shop Type</span>
            <el-radio-group v-model="shopForm.shop_type">
              <el-radio style="color: #fff;" label="1">Company</el-radio>
              <el-radio style="color: #fff;" label="2">Individual</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item style="margin-top: -20px;">
            <el-checkbox v-model="policy" style="margin-right: 10px;">
              <a
                href="https://img.nzmai.com.cn/FudZoqHWpBxPeY7Lthkk8R7--q3u"
                target="blank"
                style="color: #409EFF;"
              >IE Shop Merchant's Agreement</a>
            </el-checkbox>
            <el-popover
              placement="top-start"
              width="300"
              trigger="hover"
              content="By ticking the 'I Agree' button on the website, prospective IE Shop Merchants who do not have a paying agreement  consent and agree to the terms and conditions in the IE Shop Standard Merchant Agreement, and a copy of which is on the website."
            >
              <el-tag size="mini" slot="reference">?</el-tag>
            </el-popover>
          </el-form-item>
          <div style="margin-top: 50px; text-align: center;">
            <el-button
              @click="createShop"
              class="btn"
            >Create Your Store</el-button>
          </div>
          <div class="mobile-go-to-login">
            <span>
              Already have the account?
              <a style="color: #409EFF;" @click="goToLogin">Login</a>
            </span>
          </div>
        </el-form>
      </div>
    </div>

    <el-dialog title="Welcome" :visible.sync="registerSuccessVisible" width="40%" v-if="isMobile === false">
      <div style="padding: 0 30px;">
        <i class="el-icon-success" style="color: #67C23A; font-size: 28px;" />
        <span style="color: #67C23A; font-size: 28px; word-break: normal;"> Store created successfully.</span>
      </div>
      <div style="padding: 30px; font-size: 18px; line-height: 36px; color: #fff; word-break: normal;">
        Thank you for choosing ieShop. Please verify your email address to complete setting up your account.
      </div>
      <div style="margin-top: 10px; text-align: center;">
        <el-button
          class="btn"
          @click="confirmEmail"
        >OK</el-button>
      </div>
    </el-dialog>
    <el-dialog title="Welcome" :visible.sync="registerSuccessVisible" width="90%" v-else>
      <div style="padding: 0 30px;">
        <i class="el-icon-success" style="color: #67C23A; font-size: 22px;" />
        <span style="color: #67C23A; font-size: 22px; word-break: normal;"> Store created successfully.</span>
      </div>
      <div style="padding: 20px 30px; font-size: 16px; line-height: 26px; color: #fff; word-break: normal;">
        Thank you for choosing ieShop. Please verify your email address to complete setting up your account.
      </div>
      <div style="margin-top: 10px; text-align: center;">
        <el-button
          class="btn"
          type="primary"
          @click="confirmEmail"
        >OK</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

import beautyIndustryImage from '@/assets/img/industries/beauty.png'
import foodAndDrinkIndustryImage from '@/assets/img/industries/food_drink.png'
import takeawayIndustryImage from '@/assets/img/industries/takeaway.png'
import clothingAndFashionIndustryImage from '@/assets/img/industries/clothing_fashion.png'
import homeIndustryImage from '@/assets/img/industries/home.png'
import othersIndustryImage from '@/assets/img/industries/others.png'

import beautyIndustryQrCodeImage from '@/assets/img/industries/beauty_qr_code.png'
import foodAndDrinkIndustryQrCodeImage from '@/assets/img/industries/food_drink_qr_code.png'
import takeawayIndustryQrCodeImage from '@/assets/img/industries/takeaway_qr_code.png'
import clothingAndFashionIndustryQrCodeImage from '@/assets/img/industries/clothing_fashion_qr_code.png'
import homeIndustryQrCodeImage from '@/assets/img/industries/home_qr_code.png'
import othersIndustryQrCodeImage from '@/assets/img/industries/others_qr_code.png'

import ieshopLogo from '@/assets/img/ieshop_logo.png'

export default {
  name: 'Register',
  data() {
    return {
      hostname: window.location.hostname,
      ieshopLogo: ieshopLogo,
      isMobile: false,
      shopForm: {
        shop_admin_email: '',
        shop_admin_password: '',
        display_shop_name: '',
        shop_type: '1'
      },
      isDialogModalAppendToBody: false,
      policy: true,
      registerSuccessVisible: false,
      emailUrl: '',
      loading: false,
      industryTemplateId: -1,
      industryTemplates: this.initIndustryTemplates(),
      rules: {
        shop_admin_email: [
          {
            required: true,
            min: 6,
            message: 'Please input Email',
            trigger: 'blur'
          }
        ],
        shop_admin_password: [
          {
            required: true,
            message: 'Please input password',
            trigger: 'blur'
          }
        ],
        display_shop_name: [
          {
            required: true,
            message: 'Please input shop name',
            trigger: 'blur'
          }
        ],
        shop_type: [
          {
            required: true,
            message: '',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  beforeCreate() {
    document.title = 'ieShop'
  },
  created() {
    this.checkMobile()
  },
  mounted() {
    this.fixElementUI()
  },
  methods: {
    initIndustryTemplates() {
      const templates = [
        {
          title: 'Beauty',
          backgroundImage: beautyIndustryImage,
          templateShopId: '1149',
          pcPreviewURL: 'https://beauty.ieshop.co.nz',
          mobilePreviewURL: 'https://m.ieshop.co.nz/m/beauty/home',
          QRCodeURL: beautyIndustryQrCodeImage,
          showQRCode: false
        },
        {
          title: 'Food & Drink',
          backgroundImage: foodAndDrinkIndustryImage,
          templateShopId: '1151',
          pcPreviewURL: 'https://food.ieshop.co.nz',
          mobilePreviewURL: 'https://m.ieshop.co.nz/m/food/home',
          QRCodeURL: foodAndDrinkIndustryQrCodeImage,
          showQRCode: false
        },
        {
          title: 'Takeaway',
          backgroundImage: takeawayIndustryImage,
          templateShopId: '1154',
          pcPreviewURL: 'https://takeaway.ieshop.co.nz',
          mobilePreviewURL: 'https://m.ieshop.co.nz/m/takeaway/home',
          QRCodeURL: takeawayIndustryQrCodeImage,
          showQRCode: false
        },
        {
          title: 'Clothing & Fashion',
          backgroundImage: clothingAndFashionIndustryImage,
          templateShopId: '1152',
          pcPreviewURL: 'https://fashion.ieshop.co.nz',
          mobilePreviewURL: 'https://m.ieshop.co.nz/m/fashion/home',
          QRCodeURL: clothingAndFashionIndustryQrCodeImage,
          showQRCode: false
        },
        {
          title: 'Home',
          backgroundImage: homeIndustryImage,
          templateShopId: '1153',
          pcPreviewURL: 'https://home.ieshop.co.nz',
          mobilePreviewURL: 'https://m.ieshop.co.nz/m/home/home',
          QRCodeURL: homeIndustryQrCodeImage,
          showQRCode: false
        },
        {
          title: 'Other',
          backgroundImage: othersIndustryImage,
          templateShopId: '1150',
          pcPreviewURL: 'https://wine.ieshop.co.nz',
          mobilePreviewURL: 'https://m.ieshop.co.nz/m/wine/home',
          QRCodeURL: othersIndustryQrCodeImage,
          showQRCode: false
        }
      ]

      return templates
    },
    fixElementUI() {
      const els = document.querySelectorAll('.el-radio-button__inner')
      for (const el of els) {
        el.style.padding = '2px'
        el.style.margin = '0'
        el.style.border = 'none'
      }

      const qrEls = document.querySelectorAll('.qrcode-layout .el-dialog__wrapper')
      for (const el of qrEls) {
        el.style.width = '160px'
        el.style.height = '160px'
      }
    },
    showShopQrCode() {
      const headerEls = document.querySelectorAll('.qrcode-layout .el-dialog__headerbtn')
      for (const el of headerEls) {
        el.style.top = '-139px'
        el.style.left = '102px'
        el.style.zIndex = '1'
      }

      const dialogEls = document.querySelectorAll('qrcode-layout .el-dialog__wrapper .el-dialog')
      for (const el of dialogEls) {
        el.style.display = 'flex'
        el.style.justifyContent = 'center'
        el.style.alignItems = 'center'
      }

      const bodyEls = document.querySelectorAll('.qrcode-layout .el-dialog .el-dialog__body')
      for (const el of bodyEls) {
        el.style.position = 'relative'
        el.style.top = '-190px'
        el.style.left = '-60px'
      }
    },
    showHoverIndustryStatus(el) {
      const templateIndex = el.dataset.index
      el.style.background = 'linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)), url(' + this.industryTemplates[templateIndex].backgroundImage + ') center'

      if (this.isMobile === false) {
        const titleEl = el.querySelector('.template-title')
        titleEl.style.top = '-30px'
      } else {
        const mobileTitleEl = el.querySelector('.template-title-mobile')
        mobileTitleEl.style.color = '#409eff'
      }

      if (this.isMobile === false) {
        const buttonsEl = el.querySelector('.preview-buttons')
        buttonsEl.style.opacity = '1'
        buttonsEl.style.transition = 'opacity 1s'
        buttonsEl.style.top = '20px'

        const tickEl = el.querySelector('.tick')
        tickEl.style.opacity = '0'
      }
    },
    showUnhoverIndustryStatus(el) {
      const templateIndex = el.dataset.index
      el.style.background = 'linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)), url(' + this.industryTemplates[templateIndex].backgroundImage + ') center'

      if (this.isMobile === false) {
        const titleEl = el.querySelector('.template-title')
        titleEl.style.top = '0'
      } else {
        const mobileTitleEl = el.querySelector('.template-title-mobile')
        mobileTitleEl.style.color = '#fff'
      }

      if (this.isMobile === false) {
        const buttonsEl = el.querySelector('.preview-buttons')
        buttonsEl.style.opacity = '0'
        buttonsEl.style.transition = 'opacity 1s'
        buttonsEl.style.top = '0'

        const tickEl = el.querySelector('.tick')
        tickEl.style.opacity = '0'
      }
    },
    showClickedStatus(el) {
      const templateIndex = el.dataset.index
      el.style.background = 'linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(' + this.industryTemplates[templateIndex].backgroundImage + ') center'
      if (this.isMobile === false) {
        const buttonsEl = el.querySelector('.preview-buttons')
        buttonsEl.style.opacity = '0'

        const tickEl = el.querySelector('.tick')
        tickEl.style.opacity = '1'
      }
    },
    onMouseoverIndustryImage(e) {
      if (this.industryTemplateId === e.currentTarget.dataset.label) {
        return
      }
      this.showHoverIndustryStatus(e.currentTarget)
    },
    onMouseleaveIndustryImage(e) {
      if (this.industryTemplateId === e.currentTarget.dataset.label) {
        return
      }
      this.showUnhoverIndustryStatus(e.currentTarget)
    },
    onClickIndustryTemplate(e) {
      if (this.industryTemplateId === e.currentTarget.dataset.label) {
        return
      }

      if (this.industryTemplateId !== -1) {
        const selector = `div[data-label='${this.industryTemplateId}']`
        this.showUnhoverIndustryStatus(document.querySelector(selector))
      }

      this.showHoverIndustryStatus(e.currentTarget)
      this.showClickedStatus(e.currentTarget)
    },
    getIndustryBgImageURL(url) {
      return require(url)
    },
    checkMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.isMobile = true
      }
      console.log(this.isMobile)
    },
    createShop() {
      const emailPattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
      // 如果邮箱格式错误
      if (!emailPattern.test(this.shopForm.shop_admin_email)) {
        this.$message({
          message: 'Invalid email format',
          type: 'warning'
        })
        return
      }

      if (this.industryTemplateId === -1) {
        this.$message({
          message: 'Please selecte industry template',
          type: 'warning'
        })
        return
      }
      this.emailUrl = this.shopForm.shop_admin_email

      if (!this.policy) {
        this.$message({
          message: 'You must agree <IE Shop Merchants Agreement> in order to use IE Shop service!',
          type: 'warning'
        })
        return
      }

      this.loading = true

      var data = {
        shop_admin_email: this.shopForm.shop_admin_email,
        shop_admin_password: this.shopForm.shop_admin_password,
        display_shop_name: this.shopForm.display_shop_name,
        shop_type: this.shopForm.shop_type,
        template_shop_id: this.industryTemplateId
      }

      request({
        url: '/register',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.registerSuccessVisible = true
            this.shopForm.shop_admin_email = ''
            this.shopForm.shop_admin_password = ''
            this.shopForm.display_shop_name = ''
            this.shopForm.shop_type = '1'
            this.industryTemplateId = -1

            this.loading = false
          } else if (res.status === 40048) {
            this.$message.error('The shop name has been registered')
            this.loading = false
          } else {
            let message_error = ''
            if (
              res.status === 40001 &&
              res.data &&
              res.data.shop_admin_email
            ) {
              message_error = 'The email address is taken, please try another.'
            } else {
              message_error = res.data[Object.keys(res.data)[0]]
              message_error = message_error.toString()
            }
            this.$message.error(message_error)
            this.loading = false
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error('Register failed')
          this.loading = false
        })
    },
    confirmEmail() {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push({
          path: '/login?lang=en'
        })
      })
    },
    goToLogin() {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push({
          path: '/login?lang=en'
        })
      })
    },
    showIndustryMobileQRCode(index) {
      this.industryTemplates[index].showQRCode = true
    },
    onClickMobilePreview(url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.register-content {
  background-color: #212326;
  background-size: cover;
  min-height: 100vh;
}
.register-header {
  padding-top: 80px;
  width: 80%;
  margin: 0px auto;
}
.register-info {
  width: 80%;
  margin: 20px auto;
}
.register-header-info {
  margin-top: 10px;
  text-align: center;
}
.mobile-header {
  padding-top: 30px;
  width: 100%;
  margin: 0px auto;
}
.mobile-register-info {
  width: 100%;
  margin: 20px auto;
}
.btn {
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(45deg, #719E41, #6D9B3F);
  color: #fff !important;
  border: none;
}
.pc-form {
  width: 60%;
  padding-top: 20px;
  margin: 0 auto;
}
.pc-form-item {
  text-align: center;
}
.pc-form-input {
  max-width: 100%;
  height: 50px;
  line-height: 50px;
}
.pc-shop-type-title {
  padding-right: 20px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
}
.mobile-shop-type-title {
  padding-right: 15px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
}

.el-radio-button .el-radio-button__inner {
  padding: 2px !important;
}
.register-mobile .el-radio {
  margin-right: 10px;
}
.register-content .el-form-item__error {
  color: #ccc;
}
.register-content .el-input__inner {
  height: 50px;
  line-height: 50px;
  font-size: 16px;
}
.register-content .el-dialog {
  background-color: #212326;
}
.register-content .el-dialog__title {
  color: #fff;
}
.register-content .el-popover {
  background: #212326 !important;
  border: 1px solid #212326!important;
  color: #fff!important;
}
.register-content .el-loading-mask {
  background-color: rgba(0, 0, 0, 0.8);
}

.go-to-login {
  margin-top: 15px;
  text-align: right;
  font-size: 14px;
  color: #aaa;
}

.mobile-go-to-login {
  margin-top: 15px;
  text-align: center;
  font-size: 14px;
  color: #aaa;
}

.industry-template-grid {
  width: 255px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}

.industry-template-grid-mobile {
  width: 138px;
  height: 138px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}

.template-title {
  color: #fff;
  font-size: 1.4rem;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  top: 0;
  transition: top 1s;
}

.template-title-mobile {
  color: #fff;
  font-size: 1rem;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  top: 0;
  transition: top 1s;
}

.preview-buttons {
  position: relative;
  opacity: 0;
}

.preview-button-mobile {
  margin-top: 10px;
  margin-bottom: 5px;
}

.tick {
  font-size: 72px;
  color: #6EFF36;
  position: absolute;
  bottom: 20%;
  right: 40%;
  opacity: 0;
}

.tick-mobile {
  font-size: 72px;
  color: #6EFF36;
  position: absolute;
  bottom: 20%;
  right: 30%;
  opacity: 0;
}

.qrcode-layout {
    width: 160px;
    height: 160px;
    text-align: center;
    background: #fff;
    position: absolute;
    left: 40px !important;
}

.qrcode-layout .el-dialog {
  margin: 0 !important;
  background-color: #fff !important;
}

.qrcode-layout .el-dialog__title {
  display: none !important;
}

.qrcode-layout .el-dialog__header {
  padding: 0 !important;
  margin: 0 !important;
}

.qrcode-layout .el-dialog__body {
  margin: 0 !important;
  padding: 0 !important;
  display: flex;
}

.qrcode-layout .el-dialog__headerbtn {
  top: 0 !important;
  right: -80px !important;
}

.qrcode-layout > .el-dialog__wrapper {
  position: relative !important;
  background: #fff;
}

.template-QRCode-image {
  width: 150px;
  height: 150px;
  left: -25px;
  top: 5px;
}

.template-QRCode-close-icon {
  position: absolute;
  top: 2px;
  right: 3px;
  color: #888484;
}

.industry-template-radio-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
}
</style>
